'use client';
import { env } from '@/env';
import { getCurrentBranding } from '@/hooks/use-current-branding';
import { getSocketToken } from '@/hooks/use-web-socket/get-socket-token';
import { getQueryClient } from '@/providers/queryClient';
import { getSessionValues } from '@/providers/session-provider/get-session-values';
import { getChatManager, initChatManager } from '@pigello/pigello-chat';
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';
import { useOnMessage } from './use-on-message';

export default function PigelloChatInit() {
  const pathname = usePathname();
  const isLoginPage = pathname.includes('/login');
  const { setLastMessage } = useOnMessage();
  useEffect(() => {
    if (isLoginPage) {
      return;
    }
    const queryClient = getQueryClient();
    const branding = getCurrentBranding();
    const { restrictedToIpAddress } = getSessionValues();
    const token = getSocketToken();
    const disconnectChatManager = initChatManager({
      queryClient,
      restrictedToIpAddress: restrictedToIpAddress
        ? restrictedToIpAddress
        : undefined,
      token,
      userType: 'accounts.organizationuser',
      socketUrl: env.NEXT_PUBLIC_BASE_CHAT_URL,
      backendUrl: env.NEXT_PUBLIC_BASE_BACKEND_URL,
      branding,
      pigelloClientType: `${env.NEXT_PUBLIC_CLIENT_TYPE},frontend,1.0.0`,
      onMessage: setLastMessage,
    });

    return () => {
      disconnectChatManager?.();
    };
  }, [isLoginPage, setLastMessage]);

  useEffect(() => {
    function handleVisibilityChange() {
      if (document.visibilityState === 'visible') {
        getChatManager()?.checkConnectionHealth();
      }
    }

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  return null;
}
